import { Observable } from 'rxjs';
import { ModelOrganization } from '../../models/organizations/organization.model';

export abstract class AbstractServiceOrganization {

    abstract UpdateOrganizations(organizations: ModelOrganization[]): Observable<string>;

}